<div class="bp-modal mod-lg wrapper">
  <bp-modal-header>
    <a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      <div class="bp-modal-description">
        <div class="header">
          <img
            [alt]="'contact_header_image_alt_text' | translate"
            [src]="!newContact ? '/assets/images/edit_contact_header.svg' : '/assets/images/add_contact_header.svg'"
            class="payment-ref-logo mt-15" />
          <div class="title">
            {{ (newContact ? "modal_contact_header_new_contact" : "modal_contact_modal_header_edit_contact") | translate }}
          </div>
          <div class="title-description">
            {{ (newContact ? "modal_contact_header_new_contact_description" : "modal_contact_modal_header_edit_contact_description") | translate }}
          </div>
        </div>
      </div>
      <div class="bp-modal-body-section">
        <div class="inputs">
          <div class="pb-10">
            <bp-input
              (onKeyEnter)="save()"
              [(model)]="contact"
              [error]="contact.getValidationError('name') | translate"
              [label]="'modal_contact_name' | translate"
              [maxlength]="40"
              [placeholder]="'label_for_contact_name' | translate"
              [showCharCounter]="false"
              class="mod-ice-blue"
              field="_name"
            type="text"></bp-input>
          </div>
          <div class="pb-4">
            <bp-input
              (onKeyEnter)="save()"
              [(model)]="contact"
              [error]="contact?.getValidationError('email') | translate"
              [label]="'email' | translate"
              [placeholder]="'enter_an_address' | translate"
              class="mod-ice-blue"
              field="_email"
              type="email">
            </bp-input>
          </div>
          @if (!newContact) {
            <div class="contact-links">
              @if (inviteButtonText  !== 'invite_more_contacts') {
                <a (click)="sendInvite()" href="javascript:">
                  <img
                    class="img-responsive mod-inline"
                    src="/assets/images/invite-friend.svg"
                    alt="{{ 'invite_now_image_alt' | translate }}" />
                  {{ inviteButtonText | translate }}
                </a>
              }
              @if (inviteButtonText === 'invite_more_contacts') {
                <span class="text-green pr-20">
                  <span class="bpi__icon-check"></span>
                  {{ "taf_invite_sent" | translate }}
                </span>
              }
              <a class="items-center" (click)="delete()" (keydown.enter)="delete()" [tabIndex]="0">
                <span class="bpi__icon-block font-size-18 mr-5 stronger-text"></span>
                {{ "modal_contact_remove_contact_field" | translate }}
              </a>
            </div>
          }
          @for (field of contact.getFields(false, false); track field; let i = $index) {
            <div class="border"></div>
            <multichain-contact-address-form
              [isNewContact]="newContact"
              (deleteFieldEmitter)="deleteField(field)"
              (saveContactEmitter)="save()"
              [coinOptions]="coinOptions$ | async"
              [field]="field">
            </multichain-contact-address-form>
          }
          <a
            (click)="addNewAddress()"
            (keydown.enter)="addNewAddress()"
            [tabIndex]="0"
            class="mb-15 mt-20 fit-content items-center">
            <span class="bpi__icon-plus-circle mr-5"></span>
            {{ "add_address" | translate }}
          </a>
          <div class="div-save">
            <button (click)="save()" class="btn btn-primary button-save">
              {{ (newContact ? "save" : "save_changes") | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>